<template>
  <b-form-select v-model="selectedCode" @change="onChange">
    <b-form-select-option v-for="currency in currencyOptions" :key="currency.code" :value="currency.code" :disabled="isDisabled">
      {{ currency.name }} (<span v-html="currency.symbol"></span>)
    </b-form-select-option>
  </b-form-select>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
  name: 'CurrencyPicker',
  components: {},
  data () {
    return {
      selectedCode: 'EUR' // default currency
    }
  },
  computed: {
    ...mapGetters({
      currentCompany: "main/getCurrentCompany",
      currencyOptions: "main/getCurrencyOptions",
    }),
    isDisabled () {
      let dis = true
      if (this.currentCompany.is_premium || this.$route.name === 'QuotationCreate') {
        dis = false
      }
      return dis
    }
  },
  created () {
    if (!this.currencyOptions || this.currencyOptions.length < 1) {
      this.loadCurrencyOptions()
    }
  },
  methods: {
    ...mapActions ({
      loadCurrencyOptions: "main/loadCurrencyOptions"
    }),
    onChange () {
      this.$emit('change', this.selectedCode)
    }
  }
};
</script>
<style lang="scss">

</style>